import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Order } from '../../interfaces/orders/order';
import { Asset } from '../../interfaces/assets/asset';
import { Party } from '../../interfaces/parties/party';
import { SearchParameters } from '../../interfaces/search-parameters/search-parameters';
import { Subject, takeUntil } from 'rxjs';
import { OrderManagerService } from '../../services/order-manager/order-manager.service';
import { eOrderType, ePartyType } from '../../enums';
import { Lien } from '../../interfaces/liens/lien';

@Component({
    selector: 'lib-order-search-criteria',
    templateUrl: './order-search-criteria.component.html',
    styleUrls: ['./order-search-criteria.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrderSearchCriteriaComponent implements OnInit, OnDestroy {
    @Input() order!: Order
    searchAsset: Asset | null = null;
    searchDebtor: Party | null = null;
    searchLien: Lien | null = null;
    searchParameters: SearchParameters | null = null;
    @Input() shouldDisplayExactSimilar: boolean = true;
    @Input() shouldDisplayAssetType: boolean = false;
    @Input() shouldDisplaySearchFromDate: boolean = true;

    private unsubscribe$ = new Subject<void>();

    isDebtorSearch: boolean = false;
    isAssetSearch: boolean = false;
    isIndividual: boolean = false;
    isRegistrationNumberSearch: boolean = false;

    constructor(private orderManager: OrderManagerService) { }

    ngOnInit(): void {
        if(!this.order) {
            this.order = this.orderManager.currentOrder.value;
        }

        this.searchParameters = this.order.searchParameters!;
        this.searchDebtor = ((this.order.parties?.length ?? 0) > 0) ? this.order.parties![0] : null;
        this.searchAsset = ((this.order.assets?.length ?? 0) > 0) ? this.order.assets![0] : null;
        this.searchLien = this.order.lien ? this.order.lien : null;
        this.isDebtorSearch = this.order?.orderType?.id === eOrderType.debtorSearch || 
            this.order?.orderType?.id === eOrderType.certifiedDebtorSearch || 
            this.order?.orderTypeID === eOrderType.debtorMultiSearch;
        this.isAssetSearch = this.order?.orderType?.id === eOrderType.assetSearch ||
            this.order.orderTypeID === eOrderType.assetMultiSearch;
        this.isIndividual = this.searchDebtor?.partyTypeID === ePartyType.individualDebtor;
        this.isRegistrationNumberSearch = this.order?.orderType?.id == "RegistrationNumberSearch";
    }

    ngOnDestroy(): void {
        // Signal all subscriptions to complete
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    getAssetType() {
        return this.searchAsset?.assetTypeID.toString().replace(/([A-Z])/g, ' $1').trim();
    }

    shouldShowSearchParameters(): boolean {
        return (this.shouldDisplayExactSimilar || this.shouldDisplaySearchFromDate) && this.order.orderTypeID !== eOrderType.registrationNumberSearch;
    }
}